import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import conferences from '@/api/conferences'
import addConferences from './add.dialog.vue'
import help from '@/utils/help'
const columns = [
  {
    title: '',
    enTitle: 'Hierarchy',
    width: 100,
    dataIndex: 'sort',
    slot: 'index'
  },
  {
    title: '',
    enTitle: 'Conference Name',
    width: 300,
    dataIndex: 'name',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Location',
    width: 180,
    dataIndex: 'location',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Start Date',
    width: 150,
    dataIndex: 'startTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'End Date',
    width: 150,
    dataIndex: 'endTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Published',
    width: 120,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 120,
    dataIndex: 'status',
    slot: 'conferenceStatus'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    addConferences
  },
  data() {
    return {
      params: {},
      journalList: [],
      showAdv: false,
      isVisable: false,
      status: '',
      statusList: {
        NOT_STARTED: 'Not Started',
        IN_PROGRESS: 'On-going',
        FINISHED: 'Finished'
      },
      columns: columns,
      dataSource: [],
      startDate: [],
      endDate: [],
      titleTab: [
        { title: 'All Status', statu: 1 },
        { title: 'Published', statu: 2 },
        { title: 'Draft', statu: 3 }
      ],
      titleStatu: 1,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      user: 'getUser',
      journalId: 'getJournalId'
    })
  },
  watch: {
    journalId: {
      handler() {
        this.getList()
      },
      immediate: true
    }
  },
  mounted() {
    help.closeAutocomplete()
  },
  methods: {
    changeStatus(val) {
      this.titleStatu = val.statu
      switch (val.title) {
        case 'Published':
          this.params.released = true
          break
        case 'Draft':
          this.params.released = false
          break
        default:
          this.params.released = ''
      }
      this.getList()
    },
    changeState(val) {
      switch (val) {
        case 'Not Started':
          this.params.startTimeStart = this.$moment()
          this.params.startTimeEnd = null
          this.params.endTimeEnd = null
          this.params.endTimeStart = null
          break
        case 'On-going':
          this.params.startTimeEnd = this.$moment()
          this.params.endTimeStart = this.$moment()
          this.params.startTimeStart = null
          this.params.endTimeEnd = null
          break
        case 'Finished':
          this.params.endTimeEnd = this.$moment()
          this.params.startTimeStart = null
          this.params.startTimeEnd = null
          this.params.endTimeStart = null
          break
        default:
          this.params.startTimeEnd = null
          this.params.startTimeStart = null
          this.params.endTimeEnd = null
          this.params.endTimeStart = null
          break
      }
      this.getList()
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        journalId: this.journalId,
        pageIndex: page,
        pageSize: this.pagination.size
      })

      const { list, pageIndex, pageSize, total } = await conferences.get(data)
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    handleDateChange(date, val) {
      this.params[val + 'Start'] = date[0] ? date[0].startOf('d') : ''
      this.params[val + 'End'] = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.$refs['conferences-form'].getQuery(val.id)
      this.isVisable = true
    },
    async able(val) {
      let data = {
        version: val.version,
        released: !val.released
      }
      await conferences.released(val.id, data)
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this conference?',
        content:
          'Please be aware of once this conference is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await conferences.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Conferences has been deleted!'
        })
        this.getList()
      })
    },
    handleClear() {
      this.params = {}
      this.status = ''
      this.startDate = []
      this.endDate = []
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    }
  }
}
